import { useEffect, useState } from "react";
import axios from "axios";
import { Newspaper, ArrowUpRight } from "lucide-react";
import { API, trackEvent } from "@/lib/tracking";

export default function LatestVanguardLink() {
  const [readUrl, setReadUrl] = useState("/news/vanguard-magazine");

  useEffect(() => {
    let mounted = true;
    axios.get(`${API}/vanguard/issues`).then(({ data }) => {
      const readable = (Array.isArray(data) ? data : []).filter((issue) => issue.read_more_url || issue.pdf_url);
      const latest = readable.find((issue) => issue.is_latest) || readable[0];
      const target = latest?.read_more_url || latest?.pdf_url;
      if (!target) return;
      const url = new URL(target, process.env.REACT_APP_BACKEND_URL || window.location.origin);
      if (mounted && ["https:", "http:"].includes(url.protocol)) setReadUrl(url.href);
    }).catch(() => {
      // Keep the magazine page available if the issue feed cannot be loaded.
    });
    return () => { mounted = false; };
  }, []);

  return (
    <a
      href={readUrl}
      data-testid="hero-latest-vanguard"
      onClick={() => trackEvent("cta_click", { label: "hero_latest_vanguard" })}
      className="inline-flex items-center gap-2 rounded-full border border-white/40 bg-black/30 px-4 py-2 text-sm font-bold text-white hover:bg-white hover:text-rc-charcoal transition-colors focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-white"
    >
      <Newspaper size={18} aria-hidden="true" />
      Read Latest VanGuard
      <ArrowUpRight size={16} aria-hidden="true" />
    </a>
  );
}
